exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".countdown{display:flex;justify-content:center}.countdown__block{text-align:center;padding:0 15px;position:relative}.countdown__block:first-child{padding-left:0}.countdown__block:first-child .countdown__digit:before{display:none}.countdown__block:last-child{padding-right:0}.countdown__text{text-transform:uppercase;margin-bottom:5px}.countdown__digit{font-size:300%;font-weight:700;line-height:1;margin-bottom:5px}.countdown__digit:before{content:\":\";position:absolute;left:-5px}", ""]);

// exports
